<input [id]="field.key" type="text" [dpDayPicker]="config" (change)="onChange($event)" [mode]="'day'"
    [value]="(value ? (value | date:'dd.MM.yyyy') : '')" autocomplete="off" />
